import React from "react";
import { Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import IconChip from "./IconChip";

/**
 * The stacked "how do you want to start this?" picker used by the raise-order
 * and raise-return dialogs. Each mode is `{ key, title, hint, icon, color,
 * background }`.
 */
const ModeCards = ({ modes, value, onChange }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
    {modes.map((mode) => {
      const selected = mode.key === value;
      return (
        <div
          key={mode.key}
          role="button"
          tabIndex={0}
          onClick={() => onChange(mode.key)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onChange(mode.key);
            }
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: 12,
            border: `1px solid ${selected ? "#3b6ef6" : "#e4e7ec"}`,
            background: selected ? "#f5f8ff" : "#fff",
            borderRadius: 10,
            cursor: "pointer",
          }}
        >
          <IconChip
            icon={mode.icon}
            color={mode.color}
            background={mode.background}
          />
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 600 }}>{mode.title}</div>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {mode.hint}
            </Typography.Text>
          </div>
          {selected ? (
            <CheckCircleFilled style={{ color: "#3b6ef6", fontSize: 18 }} />
          ) : null}
        </div>
      );
    })}
  </div>
);

export default ModeCards;
